import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import { useAuth } from "../Auth/AuthPage.jsx";

const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;

const FreeButton = ({ event, onSave }) => {
    const [loading, setLoading] = useState(false);
    const { user, setFeedback } = useAuth();

    if (!user || !user.calendarAdmin) {
        return null;
    }

    const handleToggle = async () => {
        setLoading(true);
        try {
            const token = window.localStorage.getItem("authToken");
            const newValue = !event.isFree;

            const response = await fetch(`${BACKEND_HOST}/events/${event.documentId}/markFree`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    ...(token && { "Authorization": `Bearer ${token}` })
                },
                body: JSON.stringify({ data: { isFree: newValue } })
            });

            if (!response.ok) {
                throw new Error(`Failed to update event: ${response.statusText}`);
            }

            setFeedback({ message: newValue ? "Marked as free" : "Removed free mark", color: "success" });
            onSave && onSave();
        } catch (error) {
            console.error("Error updating free status:", error);
            setFeedback({ message: "Failed to update free status", color: "error" });
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <Button disabled size="small">
                <CircularProgress size={16} />
            </Button>
        );
    }

    return (
        <Button
            size="small"
            onClick={handleToggle}
            startIcon={<MoneyOffIcon />}
            variant={event.isFree ? "contained" : "outlined"}
            color="primary"
        >
            Free
        </Button>
    );
};

export default FreeButton;
